import {Checkbox, Space} from "antd";
import {Controller, useFormContext} from "react-hook-form";
import {SubSettingsFormFieldsType} from "../types";
import {SubSettingsHideFromProfileFormFieldProps} from "./types";
import {FormFieldError} from "../../../../../../design-system/form-field";

export function SubSettingsHideFromProfileFormField({
  label,
}: SubSettingsHideFromProfileFormFieldProps) {
  const {control} = useFormContext<SubSettingsFormFieldsType>();
  return (
    <div>
      <Controller
        control={control}
        name="hideFromProfile"
        render={({field: {onChange, value, ref}, fieldState: {error}}) => (
          <Space size={16} direction="vertical" style={{display: "flex"}}>
            <Checkbox
              onChange={(e) => onChange(e.target.checked)}
              ref={ref}
              checked={value}
            >
              {label}
            </Checkbox>
            <FormFieldError errorMessage={error?.message} />
          </Space>
        )}
      />
    </div>
  );
}
